<template>
  <section>
    <div class="row">
      <div class="col-12">
        <h4>Destinatarios</h4>
        <p>Seleccione las personas o áreas que van a tomar conocimiento del documento.</p>
      </div>
      <div class="wrapper-content px-3">
        <div class="row">
          <div class="col-6">
            <div class="row">
              <LmTreeSelect
                class="col-auto"
                multiple
                label="Usuarios"
                pathToGetOptions="/users/all"
                v-model="value.users"
              />
              <LmTreeSelect
                class="col-auto"
                multiple
                label="Áreas"
                pathToGetOptions="/codificatorbuilder/codificators/60ef327157c5ac23d879c0fb"
                v-model="value.areas"
              />
              <LmTreeSelect
                class="col-auto"
                multiple
                label="Subáreas"
                pathToGetOptions="/codificatorbuilder/codificators/60ef334457c5ac23d879c100"
                v-model="value.subareas"
              />
              <LmTreeSelect
                class="col-auto"
                multiple
                label="Mesas"
                pathToGetOptions="/codificatorbuilder/codificators/618c363b85dc1f76c81d32f3"
                v-model="value.mesas"
              />
            </div>
          </div>

          <div class="col-6">
              <b-list-group v-if="recipients.length">
                <b-list-group-item v-for="(recipient, index) of recipients" :key="index">
                  <div class="d-flex align-items-center">
                    <font-awesome-icon
                      class="mr-2 fa-lg"
                      :icon="recipient.icon"
                    />
                    <span class="flex-grow-1">
                      {{ recipient.name }}
                    </span>
                    <font-awesome-icon
                      class="clickable fa-lg"
                      icon="times"
                      @click="onDeleteRecipient(recipient)"
                    />
                  </div>
                </b-list-group-item>
              </b-list-group>
              <div v-else>
                <LmSvgIcon
                  icon="LmNoDataIcon"
                  width="7.5em"
                  wrapperClass="mb-4 d-flex justify-content-center"
                />
                <p class="text-center">
                  Todavía no se han seleccionado destinatarios para este documento.
                </p>
              </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'

export default {
  components: {
    LmTreeSelect
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    recipients () {
      let items = []
      for (const key in this.value) {
        const arr = this.value[key].map(el => {
          return {
            ...el,
            group: key,
            icon: this.setRecipientIcon(key)
          }
        })
        items = items.concat(arr)
      }
      return items
    }
  },
  methods: {
    setRecipientIcon (type) {
      const icons = {
        users: 'user',
        areas: 'building',
        subareas: 'users',
        mesas: 'user-friends'
      }
      return icons[type]
    },
    onDeleteRecipient (recipient) {
      this.value[recipient.group] = this.value[recipient.group].filter(item => item.id !== recipient.id)
    }
  }
}
</script>
